<template>
    <div id="testimonials">
        <PageTitle :title="title" />
        <div v-if="loading">
            <Spinner size="large" message="Loading..." line-fg-color="#000" style="padding: 5rem 0;"/>
        </div>
        <div v-else-if="nodata">
            Sorry, we can't found your data, please try to access another page.
        </div>
        <div class="testimonials" v-else>
            <div v-for="(testimonial, index) in data" :key=index class="testimonial">
                <p>
                    {{testimonial.Content}}
                </p>
                <p>
                    - {{testimonial.Name}}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import PageTitle from "../components/PageTitle"
import Spinner from 'vue-simple-spinner'

export default {
    name: "Testmonials",
    components: {
        PageTitle,
        Spinner
    },
    data(){
        return{
            title: "Testimonials",
            loading: true,
            data: [],
            nodata: false,
        }
    },
    metaInfo: {
        title: 'Testimonials | Minnesota Premier',
        meta: [{
            name: 'description', 
            content: "Minnesota Premier Properties."
        }]
    },
    mounted:function(){
        this.axios.get(`https://api.minnesotapremierrealty.com/testimonials?_sort=DisplayOrder:ASC`)
        .then((response) => {
            if(response.data.length === 0){
                this.nodata = true;
            } else {
                this.data = response.data;
                this.loading = false;
            }
        })
    },
}
</script>

<style lang="scss" scoped>
.testimonials{
    margin: 0 4rem;
    text-align: center;
}
.testimonials{
    margin: 0 auto;
    max-width: 900px;
    .testimonial{
        padding: 75px 0;
        border-bottom: 1px solid rgba($color: #000000, $alpha: 0.15);
    }
    .testimonial:last-child{
        border-bottom:none;
    }
    p{
        margin-left: 1rem;
        margin-right: 1rem; 
    }
}
</style>